import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Gamepad2 } from "lucide-react";

const JogosSection = () => {
  const featuredSites = [
    {
      name: "Free Puzzles Games",
      url: "/jogos",
      description: "Jogos de puzzle gratuitos para todas as idades.",
      imageUrl: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-O4lkLHwXsXrZdg9IXl1xMJHN/user-3t7Gu7USXXYQJfFCzCfnULQT/img-YrpjLNdCmWpGYMZFurljxzOA.png?st=2024-08-04T02%3A10%3A33Z&se=2024-08-04T04%3A10%3A33Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2024-08-04T02%3A40%3A57Z&ske=2024-08-05T02%3A40%3A57Z&sks=b&skv=2021-08-06&sig=XXsQjdT%2BDpq4NJTL8Fdf3nmFwZXTuZ8FFrPkAXRlXgs%3D"
    },
    {
      name: "Crazy Games",
      url: "/jogos",
      description: "Jogos malucos e divertidos para todos os gostos.",
      imageUrl: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-O4lkLHwXsXrZdg9IXl1xMJHN/user-3t7Gu7USXXYQJfFCzCfnULQT/img-mZqr9L7uORdqhPluVn3FKOYC.png?st=2024-08-04T02%3A11%3A14Z&se=2024-08-04T04%3A11%3A14Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2024-08-03T23%3A09%3A36Z&ske=2024-08-04T23%3A09%3A36Z&sks=b&skv=2021-08-06&sig=HVaVxW6SbrUXXfxjJELx2m7FNnR%2BUbdFP1sR0qFRfz0%3D"
    },
    {
      name: "Poki",
      url: "/jogos",
      description: "Jogos gratuitos online para todas as idades.",
      imageUrl: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-O4lkLHwXsXrZdg9IXl1xMJHN/user-3t7Gu7USXXYQJfFCzCfnULQT/img-jnKKw2Eqmb0uyOdD3HBZLBsF.png?st=2024-08-04T02%3A11%3A31Z&se=2024-08-04T04%3A11%3A31Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2024-08-04T00%3A43%3A16Z&ske=2024-08-05T00%3A43%3A16Z&sks=b&skv=2021-08-06&sig=HXeaUHUqMXXe0Rqa9/MvlwxhLxCFLuTDxR3okYX3/s8%3D"
    },
  ];

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-foreground">Sites de Jogos</h2>
          <p className="text-muted-foreground mt-4 max-w-2xl mx-auto">
            Confira esta seleção de sites com jogos online gratuitos para se divertir.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuredSites.map((site, index) => (
            <Card key={index} className="overflow-hidden transition-all hover:shadow-lg">
              <CardHeader className="p-0">
                <div className="aspect-video w-full overflow-hidden">
                  <img 
                    src={site.imageUrl} 
                    alt={site.name} 
                    className="w-full h-full object-cover"
                  />
                </div>
              </CardHeader>
              <CardContent className="pt-6">
                <CardTitle className="flex items-center gap-2">
                  <Gamepad2 className="h-5 w-5 text-primary" />
                  {site.name}
                </CardTitle>
                <CardDescription className="mt-2 text-muted-foreground">
                  {site.description}
                </CardDescription>
              </CardContent>
              <CardFooter>
                <Button asChild className="w-full">
                  <a href={site.url}>
                    Ver mais
                  </a>
                </Button>
              </CardFooter>
            </Card>
          ))}
        </div>
        
        <div className="text-center mt-10">
          <Button asChild size="lg" variant="outline" className="border-primary hover:bg-primary/10 hover:text-primary">
            <a href="/jogos">
              Ver todos os sites de jogos
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default JogosSection;